<template>
	<ReportBox class="views-report">
		<template v-slot:header>
			<h5>Views</h5>
		</template>
		<LineChart :data="data" />
	</ReportBox>
</template>

<script>
import ReportBox from './ReportBox';
import LineChart from '@/components/Charts/LineChart';
import moment from 'moment';

export default {
	components: {
		ReportBox,
		LineChart,
	},
	data() {
		return {
			data: null,
		};
	},
	methods: {
		load() {
			const startDate = moment().subtract(7, 'day');
			const dates = Array.from({ length: 7 }).map((i, index) =>
				moment(startDate.valueOf()).add(index + 1, 'day')
			);
			const labels = dates.map((d) => d.format('D'));
			const dataset = dates.map((d) => {
				return {
					label: d.format('D'),
					data: [0, 1, 2, 3, 4, 5],
				};
			});
			this.data = {
				labels: ['A', 'B'],
				dataset,
			};
		},
	},
	mounted() {
		this.load();
	},
};
</script>
